import baseAPI from '@/http'

const router = 'api/atividade/atividade'

export const activityAPI = {
  list: () => baseAPI.get(router)
}
